// 遍历树结构
export function ergodicTree(tree: object[], callback: any = () => {}, props = { id: 'id', pid: 'pid', children: 'children' }) {
  function _ergodicTree(tree: object[], parentIdPath?: any[], depth = 0) {
    const treeLength = tree.length;
    for (let i = 0; i < treeLength; i++) {
      const node: any = tree[i];
      const _idPath: any[] = parentIdPath ? [...parentIdPath, node[props.id]] : [node[props.id]];
      const _depth: number = depth + 1;
      node._idPath = _idPath;
      node._depth = _depth;
      callback(node);
      if (node[props.children] && node[props.children] instanceof Array) {
        _ergodicTree(node[props.children], _idPath, _depth);
      }
    }
    return tree;
  }

  _ergodicTree(tree);
  return tree;
}

// 深度拷贝数组/对象
declare let window: Window & { JSON: any };

export function cloneObj(obj: any) {
  let str,
    newobj: any = obj.constructor === Array ? [] : {};
  if (typeof obj !== 'object') {
    return;
  } else if (window.JSON) {
    (str = JSON.stringify(obj)), //系列化对象
      (newobj = JSON.parse(str)); //还原
  } else {
    for (const i in obj) {
      newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i];
    }
  }
  return newobj;
}

// 获取所有父节点
export function getParent(data2: any, nodeId2: any) {
  let arrRes: any[] = [];
  if (data2.length == 0) {
    if (!!nodeId2) {
      arrRes.unshift(data2);
    }
    return arrRes;
  }
  const rev = (data: any, nodeId: any) => {
    for (let i = 0, length = data.length; i < length; i++) {
      const node = data[i];
      if (node.id == nodeId) {
        arrRes.unshift(node);
        rev(data2, node.pid);
        break;
      } else {
        if (!!node.children) {
          rev(node.children, nodeId);
        }
      }
    }
    return arrRes;
  };
  arrRes = rev(data2, nodeId2);
  const result: any[] = [];
  arrRes.forEach((a: any) => {
    result.push(a.id);
  });
  return result;
}
